import axios from 'services/index';
import config from 'config/config';

/**
 * Gets the list of products
 */
export async function getProducts(queryparams) {
    return axios.get(`${config.API_URL}portal/vet/products`, { params: queryparams }).then(objResponse => {
        // Transform the data to array if its an object
        objResponse.data.data = typeof objResponse.data.data === 'object' ? Object.values(objResponse.data.data) : objResponse.data.data;

        return objResponse;
    });
}

/**
 * Gets the list of product's children
 */
export async function getProductOptions(productId,type,parentId,baseId, hideInPortalModal) {
    return axios.get(`${config.API_URL}portal/product_options/${productId}/${type}/${parentId}/${baseId}/${hideInPortalModal}`);
}

/**
 * Gets the product's detail
 */
export async function getProductDetail(quotedProductId, productId) {
    return axios.get(`${config.API_URL}portal/product/${productId}`, { params: { quoted_product_id: quotedProductId } });
}

/**
 * Gets the product's detail
 */
export async function getPrimaryImage(productId) {
    return axios.get(`${config.API_URL}portal/primary_image/${productId}`);
}

export default {
    getProducts,
    getProductOptions,
    getProductDetail,
    getPrimaryImage
};
